
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alias"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultOptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"integrationDetail"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestBodyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestBody"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestHeaders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responseType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responseXpath"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"postbackDetail"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statusMap"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spam"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redemption"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"returnField"},"name":{"kind":"Name","value":"return"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recoveryDetail"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isBulkRequests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxBulkRequests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transferIdStrategy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transferIdKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responseType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestHeaders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responseXpath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responseXRatePath"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"failRules"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failRuleType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failRuleComparison"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spamReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xpath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutoRequests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flowRedirect"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1095}};
    doc.loc.source = {"body":"# noinspection GraphQLUnresolvedReference\nquery ($alias: String!) {\n    crm(alias: $alias){\n        name\n        alias\n        defaultOptions\n        integrationDetail {\n            requestMethod\n            requestUrl\n            requestBodyType\n            requestBody\n            requestHeaders\n            responseType\n            responseXpath\n        }\n        postbackDetail {\n            strategy\n            statusMap {\n                accept\n                spam\n                cancel\n                redemption\n                returnField: return\n            }\n        }\n        recoveryDetail {\n            isBulkRequests\n            maxBulkRequests\n            transferIdStrategy\n            transferIdKey\n            responseType\n            requestUrl\n            requestHeaders\n            responseXpath\n            responseXRatePath\n        }\n        failRules {\n            failRuleType\n            failRuleComparison\n            text\n            spamReason\n            xpath\n            id\n            createdAt\n        }\n        isAutoRequests\n        flowRedirect\n    }\n\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
